import { useCallback, useMemo } from "react";
import { useComposedAddClose } from "./useComposedAddClose.js";
import { useFolderTreeCreatableActions } from "./useFolderTreeCreatableActions.js";
import { useFolderTree } from "../../contexts/folderTree.js";
function useTreeCreatableHandlers() {
    const { onCreatablePersist } = useFolderTree();
    const enabled = !!onCreatablePersist;
    const handleAddClose = useComposedAddClose();
    const { openCreatableFromType, dismissCreatable } = useFolderTreeCreatableActions();
    const handleCreatableHeaderClick = useCallback((type, consumerOnClick)=>{
        if (consumerOnClick) {
            consumerOnClick(type);
            return;
        }
        if (type === "_aio_cancel") {
            dismissCreatable();
            return;
        }
        openCreatableFromType(type);
    }, [
        dismissCreatable,
        openCreatableFromType
    ]);
    return useMemo(()=>{
        if (!enabled) {
            return undefined;
        }
        return {
            onAddClose: handleAddClose,
            handleCreatableHeaderClick
        };
    }, [
        enabled,
        handleAddClose,
        handleCreatableHeaderClick
    ]);
}
export { useTreeCreatableHandlers };
